import script from "./ContextMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ContextMenu.vue?vue&type=script&setup=true&lang=js"

import "./ContextMenu.vue?vue&type=style&index=0&id=92ed6a1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92ed6a1e"]])

export default __exports__